/**
 * BuyNowButton - 独立结算按钮
 *
 * 点击后直接跳转结账页面，不保留购物车中其他商品
 */
if (!customElements.get('buy-now-button')) {
  class BuyNowButton extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.elements = {
        loadingSpinner: this.querySelector('.loading__spinner'),
      };
      this.addEventListener('click', (e) => {
        e.preventDefault();
        if (this.classList.contains('loading')) return;
        this.startLoading();
        this.checkout().finally(() => {
          this.finishLoading();
        });
      });
    }

    get variantId() {
      return this.getAttribute('data-variant-id');
    }

    get quantity() {
      return this.getAttribute('data-quantity') || '1';
    }

    async checkout() {
      try {
        const variantIds = this.variantId.split(',');
        const quantities = this.quantity.split(',');

        const items = variantIds.map((id, index) => ({
          id: parseInt(id, 10),
          quantity: parseInt(quantities[index] || quantities[0] || 1, 10),
        }));

        // 清空购物车
        await fetch('/cart/clear.js', { method: 'POST' });

        // 添加当前商品
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
          },
          body: JSON.stringify({ items }),
        });

        if (!response.ok) {
          if (response.status === 422) {
            alert('Product unavailable or inventory shortage');
          }
          throw new Error('Add to cart failed');
        }

        // 跳转结账页
        window.location.href = '/checkout';
      } catch (error) {
        console.error('Checkout error:', error);
      }
    }

    startLoading() {
      this.setAttribute('aria-disabled', 'true');
      this.classList.add('loading');
      this.elements.loadingSpinner?.classList.remove('hidden');
    }

    finishLoading() {
      this.removeAttribute('aria-disabled');
      this.classList.remove('loading');
      this.elements.loadingSpinner?.classList.add('hidden');
    }
  }

  customElements.define('buy-now-button', BuyNowButton);
}
